import React, { useEffect, useState } from 'react';
import CryptoJS from 'crypto-js';
import { decryptId, encryptId } from '../services/apiService';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const ENCRYPTION_KEY = 'malleravindra0465'; // Same as during encryption

const CheckLogin = () => {
    const [userData, setUserData] = useState(null);
    const [userid, setUserid] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { login } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const processLogin = async () => {
            try {
                const urlParams = new URLSearchParams(window.location.search);

                const normalizeBase64 = (value) =>
                    (value || '').trim().replace(/ /g, '+');

                const decodeBase64FromUrl = (value) => {
                    try {
                        return decodeURIComponent(value);
                    } catch {
                        return value;
                    }
                };

                // Decrypt User ID
                const rawEncryptedUserId = urlParams.get('encrypted_user_id');
                const normalizedUserId = normalizeBase64(rawEncryptedUserId);
                if (normalizedUserId) {
                    const decodedUserId = decodeBase64FromUrl(normalizedUserId);
                    setUserid(decryptId(decodedUserId));
                }

                // Decrypt User Data
                const rawEncryptedUserData = urlParams.get('encreaptuserdata');
                const normalizedEncryptedUserData = normalizeBase64(rawEncryptedUserData);
                const encryptedUserData = decodeBase64FromUrl(normalizedEncryptedUserData);

                if (!encryptedUserData) {
                    throw new Error("No encrypted user data found");
                }

                const bytes = CryptoJS.AES.decrypt(encryptedUserData, ENCRYPTION_KEY);
                const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

                if (!decryptedText) throw new Error('Invalid decryption output');

                const decryptedData = JSON.parse(decryptedText);
                console.log('Decrypted user data:', decryptedData);
                setUserData(decryptedData);

                // Proceed with login
                await handleLogin(decryptedData);
            } catch (err) {
                console.error("Error processing login:", err);
                setError("Failed to log in. Invalid or corrupted data.");
                toast.error("Invalid login data!");
            } finally {
                setLoading(false);
            }
        };

        processLogin();
    }, []);

    const handleLogin = async (userData) => {
        const loginSuccess = await login(userData);

        if (loginSuccess) {
            localStorage.setItem('presentuser', JSON.stringify(userData));
            toast.success("Login successful!", { autoClose: 2000 });
            handleNavigation(userData);
            setLoading(false);
        } else {
            toast.error("Login failed. Please try again.");
            setLoading(false);
        }
    };

    const handleNavigation = (userData) => {
        console.log('Navigating user with type:', userData.user_type);

        setTimeout(() => {
            const userType = userData.user_type?.toLowerCase();

            switch (userType) {
                case "admin":
                case "administrator":
                case "staff":
                    navigate("/superadmin/dashboard");
                    break;

                case "doctor":
                case "doctors":
                    navigate(`/doctor/dashboard/${encryptId(userData.id)}`);
                    break;

                case "hospitals":
                case "hospital":
                    navigate("/hospital/dashboard");
                    break;

                case "regular_users":
                case "patient":
                    navigate("/user-dashboard");
                    break;

                case "pharmacy":
                case "seller":
                    navigate("/pharmacy/dashboard");
                    break;

                case "diagnostic":
                    navigate("/diagnostic/dashboard");
                    break;

                case "blood_bank":
                    navigate("/blood-bank/dashboard");
                    break;

                case "ambulance":
                    navigate("/ambulance-dashboard");
                    break;

                case "insurance":
                    navigate("/insurance-dashboard");
                    break;

                case "editor":
                    navigate("/editor/dashboard");
                    break;

                case "user":
                default:
                    // For unknown roles or regular users, go to home page
                    navigate("/");
                    break;
            }
        }, 1500);
    };

    if (loading) {
        return (
            <div style={{ textAlign: 'center', marginTop: '20%' }}>
                <h2>Loading, please wait...</h2>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ textAlign: 'center', marginTop: '20%', color: 'red' }}>
                <h2>{error}</h2>
            </div>
        );
    }

    return (
        <>
            <h3>Hello {userData?.name || 'Guest'}</h3>
            <h3>User ID: {userid}</h3>
            <pre>{userData && JSON.stringify(userData, null, 2)}</pre>
        </>
    );
};

export default CheckLogin;
